import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=5f93e3ea&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=5f93e3ea&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f93e3ea",
  null
  
)

export default component.exports